import {
  DEFAULT_DEFECT_LINE_WIDTH,
  type ArcGisClassBreaksRendererJson,
  type ArcGisSimpleMarkerSymbol,
} from '../map/buildDefectRulesRenderer';
import { CRACKMAP_INITIAL_ZOOM } from '../crackmaps/crackmapCatalog';
import { PAS2161_VALUE_RAG_BANDS } from './pas2161Bands';

export const PAS2161_POINT_BASE_PX = 4;

export const PAS2161_POINT_MIN_PX = 3;
export const PAS2161_POINT_MAX_PX = 10;

const PAS2161_POINT_ZOOM_SCALE = 1.08;

export function resolvePas2161PointSizePx(
  lineWidth: number = DEFAULT_DEFECT_LINE_WIDTH,
  zoom: number = CRACKMAP_INITIAL_ZOOM,
): number {
  const widthBoost =
    Number.isFinite(lineWidth) && lineWidth > DEFAULT_DEFECT_LINE_WIDTH
      ? (lineWidth - DEFAULT_DEFECT_LINE_WIDTH) * 0.25
      : 0;
  const baseSizePx = PAS2161_POINT_BASE_PX + widthBoost;
  const z = Number.isFinite(zoom) ? zoom : CRACKMAP_INITIAL_ZOOM;
  const factor = PAS2161_POINT_ZOOM_SCALE ** (z - CRACKMAP_INITIAL_ZOOM);
  const px = baseSizePx * factor;
  return Math.round(
    Math.min(PAS2161_POINT_MAX_PX, Math.max(PAS2161_POINT_MIN_PX, px)),
  );
}

function pas2161XMarker(color: string, size: number): ArcGisSimpleMarkerSymbol {
  const outlineWidth = Math.max(1, Math.round(size * 0.35));
  return {
    type: 'simple-marker',
    color,
    size,
    style: 'x',
    outline: { color, width: outlineWidth },
  };
}

export function buildPas2161Renderer(
  lineWidth: number = DEFAULT_DEFECT_LINE_WIDTH,
  zoom: number = CRACKMAP_INITIAL_ZOOM,
): ArcGisClassBreaksRendererJson {
  const size = resolvePas2161PointSizePx(lineWidth, zoom);
  return {
    type: 'class-breaks',
    field: 'VALUE',
    defaultSymbol: pas2161XMarker(PAS2161_VALUE_RAG_BANDS[0].color, size),
    classBreakInfos: PAS2161_VALUE_RAG_BANDS.map((band) => ({
      minValue: band.min,
      maxValue: band.max,
      symbol: pas2161XMarker(band.color, size),
    })),
  };
}
